module.exports = __webpack_public_path__ + "img/user-arrow.6805f290.svg";